import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import BulkMessages from './BulkMessages.vue';

const meta = {
  permissions: ['administrator', 'bulk_message_manage'],
  featureFlag: FEATURE_FLAGS.BULK_MESSAGES,
};

const bulkMessagesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/bulk-messages'),
      name: 'bulk_messages_index',
      meta,
      component: BulkMessages,
    },
  ],
};

export default bulkMessagesRoutes;
